import Button from '../../Button'
import { Container } from '../Container'

import { BUTTON_ICON_SIZES, BUTTON_SIZES } from './Buttons.constants'

import * as styles from './Buttons.module.css'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export function Flat() {
  return (
    <>
      <Container label='Button, flat, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, disabled, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            disabled
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            isLoading
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, with pre icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, with pre icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, with post icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, with post icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            isLoading
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, flat, icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            disabled
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, flat, icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, flat, circle icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            isCircle
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, flat, circle icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            disabled
            isCircle
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, flat, circle icon, loading, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            isCircle
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
